import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { initAmplitude } from 'common/amplitude';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import ReactDOM from 'react-dom';
import 'react-hot-loader';
import HttpsRedirect from 'react-https-redirect';
import { ModalProvider } from 'react-modal-hook';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { TransitionGroup } from 'react-transition-group';
import configureStore from 'store/configureStore';
import { ThemeProvider } from 'styled-components';
import 'styles/index.scss';
import theme from 'styles/theme';
import App from 'ui/containers/App';
import AuthProvider from 'ui/containers/Providers/AuthProvider';
import OSProvider, { checkActiveOS } from 'ui/containers/Providers/OSProvider';
import { SnackbarProvider } from 'ui/containers/Providers/SnackbarProvider';
import history from 'utils/history';
import { NODE_ENV, REACT_APP_SENTRY_DSN, ConfigProvider } from '../src/config.js';
import './polyfill';
import * as serviceWorker from './serviceWorker';

if (REACT_APP_SENTRY_DSN !== 'none') {
  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV4Instrumentation(history),
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

const store = configureStore({}, history);
window.appDetails = {};
const currentActiveOS = checkActiveOS();

// Initialize Amplitude Client
initAmplitude();

const Index = () => {
  return (
    // <Sentry.ErrorBoundary
    //   fallback={ErrorPage}
    //   beforeCapture={scope => {
    //     scope.setTag('location', 'ErrorBoundary');
    //   }}
    // >
    <HttpsRedirect disabled={NODE_ENV !== 'production'}>
      <ConfigProvider>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <AuthProvider>
              <OSProvider>
                <ThemeProvider theme={theme[currentActiveOS]}>
                  <SnackbarProvider>
                    <ModalProvider container={TransitionGroup}>
                      <App />
                    </ModalProvider>
                  </SnackbarProvider>
                </ThemeProvider>
              </OSProvider>
            </AuthProvider>
          </ConnectedRouter>
        </Provider>
      </ConfigProvider>
    </HttpsRedirect>
    // </Sentry.ErrorBoundary>
  );
};

ReactDOM.render(<Index />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
